import { Component } from '@angular/core';

@Component({
  selector: 'simple-test-dynamic',
  template: `
		<h4>Hello this is a simple dynamic test component</h4>
	`
})
export class SimpleTestCustomComponent {
}
